import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-aurea-slider-logo",
  templateUrl: "./aurea-slider-logo.component.html",
  styleUrls: ["./aurea-slider-logo.component.scss"],
})
export class AureaSliderLogoComponent implements OnInit {
  logos = [
    { background: "#dadad7", svg: "assets/img/aurea/aurea_logo_orange.svg" },
    { background: "#e63916", svg: "assets/img/aurea/aurea_logo_dark.svg" },
  ];

  slideConfig = {
    dots: true,
    arrows: true,
  };
  constructor() {}

  ngOnInit() {}
}
